import {FC} from 'react';
import clsx from 'clsx';
import {shallowEqual} from 'react-redux';

import {useSelector} from '~/store/hooks';
import {WebsiteThemes} from '~/utils/constants';

import LogoSvg from './svg/logo.svg';
import s from './styles.module.scss';

interface MainLogoProps {
  variant?: 'normal' | 'small';
  className?: string;
}

const MainLogo: FC<MainLogoProps> = ({variant, className}) => {
  const {title, logoType, theme, isRootPage} = useSelector(
    ({app}) => ({
      title: app.data.logo.title,
      visible: app.data.logo.display,
      logoType: app.data.page.pageCategory,
      isRootPage: app.data.page.isRootPage,
      theme: app.data.theme.code,
    }),
    shallowEqual
  );

  let LogoContent = LogoSvg;

  const rootClassNames = clsx(
    s['main-logo'],
    {
      [s['main-logo--small']]: variant === 'small',
    },
    className
  );

  return (
    <div className={rootClassNames}>
      {theme === WebsiteThemes.THEME_BLACK && isRootPage ? (
        ''
      ) : (
        <a className={s['main-logo__link']} href="/" title={title}>
          <LogoContent />
        </a>
      )}
    </div>
  );
};

export default MainLogo;
